module.exports = __webpack_public_path__ + "493a0365c1ab5318a16532966ccc3771.png";